theme.customerTemplates = function () {
  checkUrlHash();
  initEventListeners();
  resetPasswordSuccess();
  customerAddressForm();

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  function toggleRecoverPasswordForm() {
    var passwordForm = document
      .getElementById("RecoverPasswordForm")
      .classList.toggle("hide");
    var loginForm = document
      .getElementById("CustomerLoginForm")
      .classList.toggle("hide");
  }

  function initEventListeners() {
    // Show reset password form
    var recoverForm = document.getElementById("RecoverPassword");
    if (recoverForm) {
      recoverForm.addEventListener("click", function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    // Hide reset password form
    var hideRecoverPassword = document.getElementById(
      "HideRecoverPasswordLink"
    );
    if (hideRecoverPassword) {
      hideRecoverPassword.addEventListener("click", function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  }

  function resetPasswordSuccess() {
    var formState = document.querySelector(".reset-password-success");

    // check if reset password form was successfully submitted
    if (!formState) {
      return;
    }

    // show success message
    document.getElementById("ResetSuccess").classList.remove("hide");
  }

  function customerAddressForm() {
    var newAddressForm = document.getElementById("AddressNewForm");
    var addressForms = document.querySelectorAll(".js-address-form");

    if (!newAddressForm || !addressForms.length) {
      return;
    }

    // Country/province selector can take a short time to load
    setTimeout(function () {
      document.querySelectorAll(".js-address-country").forEach((el) => {
        var countryId = el.dataset.countryId;
        var provinceId = el.dataset.provinceId;
        var provinceContainerId = el.dataset.provinceContainerId;

        new Shopify.CountryProvinceSelector(countryId, provinceId, {
          hideElement: provinceContainerId,
        });
      });
    }, 1000);

    // Toggle new/edit address forms
    document.querySelectorAll(".address-new-toggle").forEach((el) => {
      el.addEventListener("click", function () {
        newAddressForm.classList.toggle("hide");
      });
    });

    document.querySelectorAll(".address-edit-toggle").forEach((el) => {
      el.addEventListener("click", function (evt) {
        var formId = evt.currentTarget.dataset.formId;
        document
          .getElementById("EditAddress_" + formId)
          .classList.toggle("hide");
      });
    });

    document.querySelectorAll(".address-delete").forEach((el) => {
      el.addEventListener("click", function (evt) {
        var formId = evt.currentTarget.dataset.formId;
        var confirmMessage = evt.currentTarget.dataset.confirmMessage;

        if (
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          )
        ) {
          if (Shopify) {
            Shopify.postLink("/account/addresses/" + formId, {
              parameters: { _method: "delete" },
            });
          }
        }
      });
    });
  }
};

$(document).ready(function () {
  theme.customerTemplates();
});
